import FormattedMessage from 'I18n/components/FormattedMessage';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { actions } from '../../constants/actions';
import { jsx as _jsx } from "react/jsx-runtime";
const CopyLinkButton = ({
  invoiceLink,
  onClickButton
}) => {
  return /*#__PURE__*/_jsx(CopyButton, {
    onClick: () => {
      onClickButton(actions.COPY);
    },
    "data-test-id": "copy-link-btn",
    responsive: false,
    size: "extra-small",
    value: invoiceLink,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "invoices.components.invoiceActionsDropdown.buttons.copyLink"
    })
  }, "copy-link-btn");
};
export default CopyLinkButton;